import React from "react";
import PropTypes from "prop-types";

const CircleSpinner = ({ className, children, text }) => (
	<div className={`circle-spinner ${className}`}>
		<div className="circle-spinner-text">{text || children}</div>
		<div className="circle-spinner-active" />
	</div>
);

CircleSpinner.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	text: PropTypes.node
};

CircleSpinner.defaultProps = {
	children: null,
	className: "",
	text: null
};

export default CircleSpinner;
